module.exports = __webpack_public_path__ + "img/zoneeMap.webp";